export default {"src":"/_next/static/media/panchang_icon.0b550c3d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};